import { DateTime } from "luxon";

import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { GenderIdentity } from "@/Common/Models/Individuals/Enums/GenderIdentity";
import { PreferredPronouns } from "@/Common/Models/Individuals/Enums/PreferredPronouns";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { relativeStore } from "../Stores/RelativeStore";

import "./Demographic.scss";

function DemographicView(): JSX.Element {
    const relative = relativeStore.GetCurrent();
    const { getText } = useTranslation();

    return (
        <div className="tabComponent demographic">
            <div className="tabComponent-main patient-prof">
                <div className="block separated">
                    <div className="heading">
                        <h3 className="thin-font">{getText("PersonalInformationLabel")}</h3>
                    </div>
                    <div className="patient-profile fxd-wdth-container" data-cy="patientProfile-view">
                        <div className="tb">
                            <div className="tbc">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("PrefixLabel")}</label></td>
                                            <td className="c2"><strong data-cy="patientProfile-patientInfo-prefix">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(relative.PrefixLookupId))}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("FirstNameLabel")}</label></td>
                                            <td className="c2"><strong data-cy="patientProfile-patientInfo-firstName">{MyleHelper.ReplaceEmptyString(relative.FirstName)}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("LastNameLabel")}</label></td>
                                            <td className="c2"><strong data-cy="patientProfile-patientInfo-lastName">{MyleHelper.ReplaceEmptyString(relative.LastName)}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("PreferredNameLabel")}</label></td>
                                            <td className="c2"><strong data-cy="patientProfile-patientInfo-preferredName">{MyleHelper.ReplaceEmptyString((relative.PreferredName))}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("PreferredPronounsLabel")}</label></td>
                                            <td className="c2"><strong data-cy="patientProfile-patientInfo-preferredPronouns">{MyleHelper.ReplaceEmptyString(getText(relative.PreferredPronouns ? `Enums_PreferredPronouns_${PreferredPronouns[relative.PreferredPronouns]}` : ""))}</strong></td>
                                        </tr>
                                        {relative.PreferredPronouns === PreferredPronouns.Other && (
                                            <tr>
                                                <td />
                                                <td className="c2"><strong data-cy="patientProfile-patientInfo-ssn">{MyleHelper.ReplaceEmptyString(relative.SpecifiedPreferredPronouns)}</strong></td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("SexAtBirthLabel")}</label></td>
                                            <td className="c2"><strong data-cy="patientProfile-patientInfo-sexAtBirth">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(relative.GenderLookupId))}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("GenderIdentityLabel")}</label></td>
                                            <td className="c2"><strong data-cy="patientProfile-patientInfo-genderIdentity">{MyleHelper.ReplaceEmptyString(getText(relative.GenderIdentity ? `Enums_GenderIdentity_${GenderIdentity[relative.GenderIdentity]}` : ""))}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="c1"><label className="form-label">{getText("DateofBirthLabel")}</label></td>
                                            <td className="c2">
                                                <strong data-cy="patientProfile-patientInfo-dt">
                                                    {MyleHelper.ReplaceEmptyString(relative.DateOfBirth == null ? "" : DateTime.fromJSDate(relative.DateOfBirth).toFormat("yyyy-MM-dd"))}
                                                </strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tabComponent-footer ws-subfooter patient-profile">
                <div className="tb patient-profile-footer">
                    <div className="tbc pull-right">
                        <ButtonControl
                            className="btn btn-primary pull-right"
                            onClick={() => sessionStore.dispatch(LocalOperations.Relative.EditProfile)}
                            label={getText("EDITLabel")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export { DemographicView };
